import React from "react";
import { Helmet } from "react-helmet";
import { truncateText, toAbsoluteMediaUrl } from "../../utils/seo";

const SeoHead = ({
  title,
  description,
  keywords,
  canonical,
  image,
  imageAlt,
  type = "website",
  noIndex = false,
  jsonLd,
  siteName,
  publishedTime,
}) => {
  const robots = noIndex ? "noindex, nofollow" : "index, follow";
  const desc = truncateText(description, 160);
  const ogImage = toAbsoluteMediaUrl(image, canonical);

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {desc ? <meta name="description" content={desc} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={robots} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:type" content={type} />
      {title ? <meta property="og:title" content={title} /> : null}
      {desc ? <meta property="og:description" content={desc} /> : null}
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      {imageAlt ? <meta property="og:image:alt" content={imageAlt} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:locale" content="fa_IR" />
      {siteName ? <meta property="og:site_name" content={siteName} /> : null}
      {publishedTime ? (
        <meta property="article:published_time" content={publishedTime} />
      ) : null}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {desc ? <meta name="twitter:description" content={desc} /> : null}
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}
      {canonical ? <meta name="twitter:url" content={canonical} /> : null}
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
};

export default SeoHead;
